import { registerQuery } from 'data-fetching-client';
import { getRouting } from 'FormsUI/api/Routing';
export const GET_FORM_ROUTING_FIELD_NAME = 'formRouting';
export const GET_FORM_ROUTING = registerQuery({
  fieldName: GET_FORM_ROUTING_FIELD_NAME,
  args: ['formGuid'],
  fetcher: getRouting
});